module.exports = __webpack_public_path__ + "static/media/mail.4da59938.svg";